import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getStoreById({ commit, state }, { id }) {
    try {
      let store = state.stores?.find((p) => p.id === id);
      if (!store) {
        let response = await requestAxios({
          url: `/awy/api/v1/ecommerce/stores/${id}`,
          method: "GET",
        });
        store = response.data.data;
      }
      commit(MutationsType.SET_STORE, store);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllStores({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/stores",
        method: "GET",
      });
      commit(MutationsType.SET_STORES, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveStore({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/stores",
        method: "POST",
        data: data,
      });
      commit(MutationsType.ADD_STORE, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateStore({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/stores/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_STORE, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteStore({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/ecommerce/stores/${id}`,
        method: "DELETE",
      });
      commit(MutationsType.DELETE_STORE, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetStore({ commit }) {
    commit(MutationsType.SET_STORE, null);
  },
  resetModuleStore({ commit }) {
    commit(MutationsType.SET_STORE, null);
    commit(MutationsType.SET_STORES, null);
  },
};
